/* eslint-disable no-restricted-imports */
import { Decorator } from 'final-form'
import finalFormCreateDecorator, { FieldPattern } from 'final-form-calculate'

type Update = (...args: any[]) => any

type Updates = { [fieldName: string]: Update } | Update

export interface Calculation {
  field: FieldPattern
  updates: Updates
  isEqual?: (a: any, b: any) => boolean
}

// final-form-calculate pode passar prevValues undefined na primeira execução; normaliza pra {} para os updates que o leem.
function normalizeUpdates(updates: Updates): Updates {
  if (typeof updates === 'function') {
    return (value: any, field: any, allValues?: any, prevValues?: any) =>
      updates(value, field, allValues, prevValues ?? {})
  }

  return Object.fromEntries(
    Object.entries(updates).map(([fieldName, update]) => [
      fieldName,
      (value: any, allValues?: any, prevValues?: any) => update(value, allValues, prevValues ?? {}),
    ])
  )
}

export function createDecorator<FormValues = any>(...calculations: Calculation[]): Decorator<FormValues> {
  const normalized = calculations.map((calculation) => ({
    ...calculation,
    updates: normalizeUpdates(calculation.updates),
  }))

  return (finalFormCreateDecorator(...normalized) as unknown) as Decorator<FormValues>
}
